import TriggerCode from './models/TriggerCode';
var EasterEgg = /** @class */ (function () {
    function EasterEgg() {
        this.isInitialized = false;
        this.triggerCodes = [];
        this.activeTriggerCodes = [];
        this.activeTriggerCodeIndex = 0;
    }
    EasterEgg.prototype.initialize = function () {
        var _this = this;
        if (this.isInitialized) {
            return;
        }
        this.isInitialized = true;
        document.addEventListener('keypress', function (event) {
            var character = event.key;
            // ignore keys like SHIFT
            if (character.length > 1) {
                return;
            }
            if (_this.activeTriggerCodes.length) {
                _this.activeTriggerCodes = _this.activeTriggerCodes.filter(function (x) { return x.characterIsValid(character, _this.activeTriggerCodeIndex); });
                _this.activeTriggerCodes.forEach(function (x) { return x.invokeCallbackIfIsLastCharacter(_this.activeTriggerCodeIndex); });
                // remove all completed trigger codes
                _this.activeTriggerCodes = _this.activeTriggerCodes.filter(function (x) { return !x.isLastCharacter(_this.activeTriggerCodeIndex); });
            }
            else {
                _this.activeTriggerCodeIndex = 0;
                _this.activeTriggerCodes = _this.triggerCodes.filter(function (x) { return x.characterIsValid(character, _this.activeTriggerCodeIndex); });
            }
            _this.activeTriggerCodeIndex++;
        });
    };
    EasterEgg.prototype.register = function (triggerCode, callback) {
        this.initialize();
        this.triggerCodes.push(new TriggerCode(triggerCode, callback));
        return this;
    };
    return EasterEgg;
}());
export default new EasterEgg();
//# sourceMappingURL=EasterEgg.js.map